import { Pipe, PipeTransform } from '@angular/core';
import { WarehouseTransferRequest } from '../models/entities/warehouse-transfer-request';


@Pipe({
  name: 'warehouse-transfer-pipe'
})

export class WarehouseTransferRequestPipe implements PipeTransform {
  
  constructor(){}
 
  
  transform(warehouseTransferRequest: WarehouseTransferRequest, field: string): any {
    let result = warehouseTransferRequest[field];

    if (field == 'quantities') {

        let requestedQty : number = warehouseTransferRequest.requestedQuantity;      
        let confirmedQty : number = warehouseTransferRequest.confirmedQuantity;      
        let assignedQty : number = warehouseTransferRequest.assignedQuantity;

        let cls = 'assigned-ok';
        if (! warehouseTransferRequest.balanced) cls = 'assigned-ko';

        result = "<div class ='display-flex'>"
            + " <div class='requested'> " + requestedQty + " </div> "
            + " <div class='confirmed'> " + confirmedQty + " </div> "
            + " <div class='" + cls + "'> " + assignedQty + " </div> "
            + " </div>"
    }

    return result;
  }


}

